import { render, staticRenderFns } from "./PopupUpdateTask.vue?vue&type=template&id=5c6b977f&scoped=true"
import script from "./PopupUpdateTask.vue?vue&type=script&lang=js"
export * from "./PopupUpdateTask.vue?vue&type=script&lang=js"
import style0 from "./PopupUpdateTask.vue?vue&type=style&index=0&id=5c6b977f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6b977f",
  null
  
)

export default component.exports